import autoload from "./autoload";
import auth from "./mixins/auth";
import cart from "./mixins/cart";
import initDom from "./mixins/init_dom";

// SVG Icons
import upsIcon from "./components/icons/upsIcon.vue";
import fedExIcon from "./components/icons/fedExIcon.vue";
import dhlIcon from "./components/icons/dhlIcon.vue";
import cerakoteLogo from "./components/icons/cerakoteLogo.vue";
import bestShippingRates from "./components/icons/bestShippingRates.vue";
import getOrderFast from "./components/icons/getOrderFast.vue";
import directToDoor from "./components/icons/directToDoor.vue";

//SVG Flags
import australiaFlag from "./components/icons/flags/australiaFlag.vue";
import canadaFlag from "./components/icons/flags/canadaFlag.vue";
// import colombiaFlag from "./components/icons/flags/colombiaFlag.vue";
import germanyFlag from "./components/icons/flags/germanyFlag.vue";
import hongKongFlag from "./components/icons/flags/hongKongFlag.vue";
// import japanFlag from "./components/icons/flags/japanFlag.vue";
import southKoreaFlag from "./components/icons/flags/southKoreaFlag.vue";
import ukFlag from "./components/icons/flags/ukFlag.vue";
import swedenFlag from "./components/icons/flags/swedenFlag.vue";
import usaFlag from "./components/icons/flags/usaFlag.vue";
import asiaGlobalMap from "./components/icons/flags/asiaGlobalMap.vue";
import europeGlobalMap from "./components/icons/flags/europeGlobalMap.vue";
import middleEastGlobalMap from "./components/icons/flags/middleEastGlobalMap.vue";
import euFlag from "./components/icons/flags/euFlag.vue";
import germanyAndAustriaFlag from "./components/icons/flags/germanyAndAustriaFlag.vue";
// import malaysiaFlag from "./components/icons/flags/malaysiaFlag.vue";
import franceFlag from "./components/icons/flags/franceFlag.vue";
import southAfricaFlag from "./components/icons/flags/southAfricaFlag.vue";

//SVG Flag Icons
import australiaIcon from "./components/icons/flag_icons/australiaIcon.vue";
import canadaIcon from "./components/icons/flag_icons/canadaIcon.vue";
// import colombiaIcon from "./components/icons/flag_icons/colombiaIcon.vue";
import franceIcon from "./components/icons/flag_icons/franceIcon.vue";
import germanyIcon from "./components/icons/flag_icons/germanyIcon.vue";
import hongKongIcon from "./components/icons/flag_icons/hongKongIcon.vue";
import indiaIcon from "./components/icons/flag_icons/indiaIcon.vue";
import israelIcon from "./components/icons/flag_icons/israelIcon.vue";
import italyIcon from "./components/icons/flag_icons/italyIcon.vue";
import japanIcon from "./components/icons/flag_icons/japanIcon.vue";
import saudiArabiaIcon from "./components/icons/flag_icons/saudiArabiaIcon.vue";
import malaysiaIcon from "./components/icons/flag_icons/malaysiaIcon.vue";
import southKoreaIcon from "./components/icons/flag_icons/southKoreaIcon.vue";
import spainIcon from "./components/icons/flag_icons/spainIcon.vue";
import swedenIcon from "./components/icons/flag_icons/swedenIcon.vue";
import taiwanIcon from "./components/icons/flag_icons/taiwanIcon.vue";
import turkeyIcon from "./components/icons/flag_icons/turkeyIcon.vue";
import uaeIcon from "./components/icons/flag_icons/uaeIcon.vue";
import ukIcon from "./components/icons/flag_icons/ukIcon.vue";
import unIcon from "./components/icons/flag_icons/unIcon.vue";
import usaIcon from "./components/icons/flag_icons/usaIcon.vue";
import austriaIcon from "./components/icons/flag_icons/austriaIcon.vue";
import southAfricaIcon from "./components/icons/flag_icons/southAfricaIcon.vue";

autoload();

window.app = new Vue({
  el: "#vue-international-pages",

  mixins: [initDom, auth, cart],

  components: {
    upsIcon,
    fedExIcon,
    dhlIcon,
    cerakoteLogo,
    australiaFlag,
    australiaIcon,
    canadaFlag,
    // colombiaFlag,
    germanyFlag,
    hongKongFlag,
    // japanFlag,
    southKoreaFlag,
    ukFlag,
    swedenFlag,
    usaFlag,
    canadaIcon,
    // colombiaIcon,
    franceIcon,
    germanyIcon,
    hongKongIcon,
    indiaIcon,
    israelIcon,
    italyIcon,
    japanIcon,
    saudiArabiaIcon,
    malaysiaIcon,
    southKoreaIcon,
    spainIcon,
    swedenIcon,
    taiwanIcon,
    turkeyIcon,
    uaeIcon,
    ukIcon,
    unIcon,
    usaIcon,
    austriaIcon,
    asiaGlobalMap,
    middleEastGlobalMap,
    europeGlobalMap,
    euFlag,
    bestShippingRates,
    getOrderFast,
    directToDoor,
    germanyAndAustriaFlag,
    southAfricaFlag,
    franceFlag,
    southAfricaIcon,
    // malaysiaFlag
  },
});
